var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tax-proile"},[_c('TaxProfiles',{ref:"TaxProfiles",attrs:{"isOPS":true,"level":"Property"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }